import { Component, ElementRef, EventEmitter, Output, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AiVoiceState, BotService, caption } from 'app/ibm-bot/bot.service';
import { LlmService } from 'app/services/llm.service';
import { SharedModule } from "app/shared/shared.module";
import { HeaderService } from '../header/header.service';
import { TtsStreamService } from 'app/services/tts-stream.service';
import { AI_BOT_CONFIG, HttpLoader } from 'app/app.config';
import { Subject, Subscription } from 'rxjs';
import { firstValueFrom } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { take } from 'rxjs/operators';
import { BotSocketService } from 'app/services/bot-socket.service';
import { TtstreamService } from 'app/services/ttstream.service';

declare const webkitSpeechRecognition: any;
declare const annyang: any;

@Component({
    selector: 'app-ai-voice',
    templateUrl: './ai-voice.component.html',
    styleUrl: './ai-voice.component.scss',
    standalone: false
})
export class AiVoiceComponent {

  @ViewChild('scrollbarContainer') scrollbarContainer!: ElementRef;
  @Output() historyCreated = new EventEmitter<any>();
  @ViewChild('content') contentRef!: ElementRef<HTMLDivElement>;

  private sub!: Subscription;
  // state: aiBotState = 'idle';
  typescript = "";

  aiState: 'idle' | 'listening' | 'speaking' = 'idle';

  private destory$ = new Subject<void>();

  stream?: MediaStream;
  isMicMuted: boolean = false;
  isMicActive = false;
  transcriptLines: string[] = [];
  private answerLines: string[] = [];
  private lineIndex: number = 0;
  answerText: string = "";
  userQuery = '';
  botAnswer = '';
  isLoggedIn: boolean = true;
  isLoggedUserId: any;
  isViewTranscript: boolean;
  aiAnswer: string | null = "";
  aiBotDate: any;
  aiLoading: boolean = false;
  typedAnswer: string = '';
  typingSpeed: number = 25;
  isLoggedUser: string = '';
  typingInterval: any;
  isTyping: boolean;
  aiBotTransData: any[] = [];
  state: AiVoiceState = 'idle';
  caption: caption[] = [];
  isBotBusy = false;
  liveSubtitle: any = '';

  private lastProcessedQuery = '';
  private isProcessing = false;


  private recognition: any;
  private mediaStream: MediaStream | null = null;
  private scrollbarHeight: boolean = true;
  private greetingAudioDone = false;
  private greetingTextDone = false;

  apiUrl = AI_BOT_CONFIG.agent.socketUrl;
  text = '';
  voice = 'af_sky';
  speed = 1.15;
  sampleRate = 16000;
  progressive = true;

  status = '';
  isStreaming = false;

  // Audio
  audioContext!: AudioContext;
  audioQueue: Float32Array[] = [];
  scheduledTime = 0;
  isPlaying = false;

  private mediaRecorder!: MediaRecorder;
  private userChunks: Blob[] = [];
  private recordedUserChunks: Float32Array[] = [];
  private micSource!: MediaStreamAudioSourceNode;
  private processor!: ScriptProcessorNode;

  private analyser!: AnalyserNode;
  private microphone!: MediaStreamAudioSourceNode;
  dataArray!: Uint8Array<ArrayBuffer>;

  private silenceStart = 0;
  private silenceThreshold = 0.02; // noise sensitivity
  private silenceDuration = 2000; // 2 seconds

  isBelowIpadSize: boolean = window.innerWidth < 768 ? true : false; // Check if screen size is below iPad size initially

  constructor(
    private llmService: LlmService,
    private router: Router,
    private route: ActivatedRoute,
    private botService: BotService,
    private botSocketService: BotSocketService,
    private headerService: HeaderService,
    private ttsSocketService: TtsStreamService,
    private httpLoader: HttpLoader,
  ) { }

  async ngOnInit() {

    this.connect();
    this.registerSocketEvents(); // ✅ REQUIRED
    this.loadUserAndSpeak();

    this.isLoggedUserId = localStorage.getItem('user_id');
  }

  connect() {
    this.ttsSocketService.connect(this.apiUrl);
  }

  registerSocketEvents() {

    this.ttsSocketService.streamStarted$.subscribe(data => {
      this.status = `Streaming at ${data.sample_rate}Hz`;
    });

    this.ttsSocketService.audioChunk$.subscribe(data => {
      this.handleAudioChunk(data);
    });

    this.ttsSocketService.streamComplete$.subscribe(() => {
      this.status = 'Streaming Complete';
      this.isStreaming = false;

      this.waitForPlaybackToFinish(); // ✅ ADD THIS
    });


    this.ttsSocketService.error$.subscribe(err => {
      this.status = err.error;
    });

    this.ttsSocketService.connectionStatus$.subscribe(status => {
      this.status = status ? 'Connected' : 'Disconnected';
    });
  }

  private waitForPlaybackToFinish() {
    const check = () => {
      if (this.audioContext.currentTime >= this.scheduledTime) {
        this.ttsSocketService.notifyPlaybackEnded(); // ✅ TRIGGER
      } else {
        requestAnimationFrame(check);
      }
    };

    check();
  }


  handleAudioChunk(data: any) {

    const audioData = atob(data.chunk);
    const audioBytes = new Uint8Array(audioData.length);

    for (let i = 0; i < audioData.length; i++) {
      audioBytes[i] = audioData.charCodeAt(i);
    }

    const pcm16 = new Int16Array(audioBytes.buffer);
    const float32 = new Float32Array(pcm16.length);

    for (let i = 0; i < pcm16.length; i++) {
      float32[i] = pcm16[i] / 32768.0;
    }

    this.audioQueue.push(float32);

    if (!this.isPlaying) {
      this.playAudioQueue();
    }
  }

  async playAudioQueue() {

    if (this.isPlaying) return;
    this.isPlaying = true;

    while (true) {

      if (this.audioQueue.length === 0) {
        if (!this.isStreaming) break; // ✅ Exit properly
        await new Promise(r => setTimeout(r, 20));
        continue;
      }

      const chunk: any = this.audioQueue.shift()!;

      const buffer = this.audioContext.createBuffer(
        1,
        chunk.length,
        this.sampleRate
      );

      buffer.copyToChannel(chunk, 0);

      const source = this.audioContext.createBufferSource();
      source.buffer = buffer;
      source.connect(this.audioContext.destination);

      if (this.scheduledTime < this.audioContext.currentTime) {
        this.scheduledTime = this.audioContext.currentTime;
      }

      source.start(this.scheduledTime);
      this.scheduledTime += buffer.duration;
    }

    this.isPlaying = false;
  }


  async loadUserAndSpeak(): Promise<void> {

    try {

      const data: any = await firstValueFrom(
        this.headerService.getCurrentUserDetail().pipe(take(1))
      );

      const user = data?.userDetail;
      if (!user) return;

      this.isLoggedUser = user.first_name || 'User';

      const greeting =
        `${this.getGreetingPrefix()} ${this.isLoggedUser}, I am your AI Assistant. May I help you?`;

      if (!greeting.trim()) return;

      this.transcriptLines = [greeting];
      this.greetingTextDone = true;

      this.resetState();

      // Init audio
      if (!this.audioContext || this.audioContext.state === 'closed') {
        await this.initAudio();
      }

      //  WAIT for socket handshake
      await this.ttsSocketService.connect(this.apiUrl);

      //  Subscribe BEFORE emitting
      this.ttsSocketService.streamComplete$
        .pipe(take(1))
        .subscribe(() => {
          console.log('Server stream complete');
        });

      this.aiState = 'speaking';

      this.ttsSocketService.playbackEnded$
        .pipe(take(1))
        .subscribe(() => {
          console.log('Playback finished fully');
          this.greetingAudioDone = true;
          this.checkGreetingComplete();
          this.aiState = 'listening';
        });

      const payload = {
        text: greeting,
        voice: this.voice || 'af_sky',
        speed: this.speed || 1.15,
        sample_rate: this.sampleRate || 24000,
        progressive: true
      };

      this.ttsSocketService.startStreaming(payload);

    } catch (error) {
      console.error('Failed to load greeting:', error);
    }
  }



  private getGreetingPrefix(): string {
    const hour = new Date().getHours();

    if (hour < 12) return 'Good morning';
    if (hour < 18) return 'Good afternoon';
    return 'Good evening';
  }



  stopStreaming() {
    this.ttsSocketService.disconnect();

    if (this.audioContext && this.audioContext.state !== 'closed') {
      this.audioContext.close();
    }

    this.resetState();
  }


  async initAudio(): Promise<void> {
    this.audioContext = new AudioContext({
      sampleRate: this.sampleRate,
      latencyHint: 'interactive'
    });

    if (this.audioContext.state === 'suspended') {
      await this.audioContext.resume();
    }

    this.scheduledTime = this.audioContext.currentTime;
  }



  resetState() {
    this.audioQueue = [];
    this.scheduledTime = 0;
    this.isPlaying = false;
  }


  private checkGreetingComplete() {
    if (this.greetingAudioDone && this.greetingTextDone) {
      this.onGreetingFinished();
    }
  }


  private onGreetingFinished() {
    console.log('Greeting fully done (audio + text)');

    this.transcriptLines = ['AI Listening... Say something'];

    setTimeout(() => {
      this.startMic();
    }, 150);
  }

  // ------------------------

  // Start microphone and update transcript as user speaks


  // async startMic(): Promise<void> {

  //   if (this.isMicActive) return;

  //   this.isMicActive = true;

  //   await this.initNoiseDetection();

  //   if (!this.transcriptLines.length) {
  //     this.transcriptLines = ['AI Listening... Say something'];
  //   }

  //   this.botService.startListening(
  //     (query: string, isFinal = false, confidence?: number) => {

  //       if (!query) return;

  //       this.transcriptLines = [query];

  //       if (confidence !== undefined) {
  //         console.log(`Confidence: ${(confidence * 100).toFixed(2)}%`);
  //       }

  //       console.log(query, 'query data');


  //       if (isFinal) {

  //         this.stopMic();

  //         this.transcriptLines = [];

  //         this.userQuery = query;

  //         this.getBotAnswer(query);
  //       }
  //     }
  //   );
  // }

  // async startMic(): Promise<void> {
  //   if (this.isMicActive) return;

  //   this.isMicActive = true;
  //   this.isProcessing = false;

  //   await this.initNoiseDetection();

  //   if (!this.transcriptLines.length) {
  //     this.transcriptLines = ['Listening... Speak now'];
  //   }

  //   this.botService.startListening(
  //     (query: string, isFinal = false, confidence?: number) => {

  //       console.log(query, '------------------query----------------------');


  //       if (!query) return;

  //       // Show live transcript (interim + final)
  //       this.transcriptLines = [query];

  //       if (confidence !== undefined) {
  //         console.log(`Confidence: ${(confidence * 100).toFixed(2)}%`);
  //       }

  //       console.log(query, 'query data');

  //       // Prevent duplicate processing
  //       if (isFinal && !this.isProcessing && query !== this.lastProcessedQuery) {

  //         this.isProcessing = true;
  //         this.lastProcessedQuery = query;

  //         // ⏳ Small delay ensures speech is fully completed
  //         setTimeout(() => {
  //           this.stopMic();

  //           this.transcriptLines = [];
  //           this.userQuery = query;

  //           this.getBotAnswer(query);
  //         }, 300); // tweak 200–500ms if needed
  //       }
  //     }
  //   );
  // }

  async startMic(): Promise<void> {
    if (this.isMicActive) return;

    this.isMicActive = true;
    this.isProcessing = false;

    await this.initNoiseDetection();

    if (!this.transcriptLines.length) {
      this.transcriptLines = ['Listening... Speak now'];
    }

    this.botService.startListening(
      (query: string, isFinal = false, confidence?: number) => {

        if (!query) return;

        const normalizedQuery = query.trim().toLowerCase();

        // Show live transcript
        this.transcriptLines = [query];

        if (confidence !== undefined) {
          console.log(`Confidence: ${(confidence * 100).toFixed(2)}%`);
        }

        // Handle final speech
        if (isFinal && !this.isProcessing && normalizedQuery !== this.lastProcessedQuery) {

          this.isProcessing = true;
          this.lastProcessedQuery = normalizedQuery;

          this.stopMic();

          this.transcriptLines = ['Processing...'];
          this.userQuery = query;

          this.getBotAnswer(query);
        }
      }
    );
  }

  // ------------------------

  // Toggle mic on/off (mute/unmute)
  async toggleMic(): Promise<void> {

    // Prevent rapid clicking
    if (this.isBotBusy) return;

    this.isMicMuted = !this.isMicMuted;

    if (this.isMicMuted) {
      await this.stopMicSafe();
    } else {
      await this.startMicSafe();
    }
  }

  async stopMicSafe(): Promise<void> {
    if (!this.isMicActive) return;

    this.aiState = 'idle';
    this.isMicActive = false;

    // Stop recognition
    this.botService.stopListening?.();

    // Stop streaming
    this.botSocketService?.stopStreaming?.();

    // Stop media stream
    if (this.mediaStream) {
      this.mediaStream.getTracks().forEach(track => track.stop());
      this.mediaStream = null;
    }

    this.liveSubtitle = '';
  }

  async startMicSafe(): Promise<void> {
    if (this.isMicActive) return;

    this.isMicActive = true;
    this.aiState = 'listening';

    await this.startMic(); // your existing method
  }



  async getBotAnswer(query: string): Promise<void> {

    if (this.isBotBusy) return;
    this.isBotBusy = true;

    this.aiLoading = true;
    this.isTyping = true;
    this.typedAnswer = '';

    // Reset transcript
    this.transcriptLines = [];

    // Push user query
    this.transcriptLines.push(query);

    const llmPayload = {
      user_name: this.isLoggedUser,
      session_id: localStorage.getItem('session_id'),
      query
    };

    // Stop mic before LLM call
    this.botService.stopListening();
    this.isMicActive = false;

    this.botService.llmAIVoiceQuery(llmPayload).subscribe({

      next: async (result: any) => {

        this.botAnswer = result?.response || '';

        if (!this.botAnswer.trim()) {
          this.resetBotState();
          return;
        }

        // Split AI answer into lines
        this.answerLines = this.botAnswer
          .split('\n')
          .map(l => l.trim())
          .filter(Boolean);

        // Clear previous AI lines
        this.transcriptLines = [];

        // Start progressive rendering
        this.renderAnswerLineByLine();

        // Start typing effect
        this.startTypingEffect(this.botAnswer);

        // Prepare TTS payload
        const ttsPayload = {
          text: this.botAnswer,
          voice: this.voice || 'af_sky',
          speed: this.speed || 1.15,
          sample_rate: this.sampleRate || 24000,
          progressive: this.progressive ?? true
        };

        this.aiState = 'speaking';

        // Subscribe BEFORE streaming
        this.ttsSocketService.playbackEnded$
          .pipe(take(1))
          .subscribe(() => {

            console.log('AI playback fully completed');
            this.aiState = 'listening';
            this.resetBotState();
            this.startMic();   // 🎤 restart mic after AI finishes
          });

        // Start streaming
        this.ttsSocketService.startStreaming(ttsPayload);

        // Save conversation
        this.aiBotTransData.push({
          question_id: '',
          sequence_id: Date.now(),
          bot_type: 'bot',
          question: query.trim(),
          answer: this.botAnswer,
          source_doc: '',
          search: true
        });

        this.aiBotTransData.sort(
          (a, b) =>
            new Date(a.timestamp || a.sequence_id).getTime() -
            new Date(b.timestamp || b.sequence_id).getTime()
        );

        // Save history
        // const historyPayload = {
        //   user_id: parseInt(this.isLoggedUserId),
        //   question: query.trim(),
        //   answer: this.botAnswer,
        //   question_type: "history",
        //   bot_type: "bot",
        //   sequence_id: new Date().getTime(),
        //   session_id: localStorage.getItem('session_id'),
        //   query_type: "generic",
        //   source_doc: ""
        // };

        // this.botService.createHistory(historyPayload).subscribe(
        //   (result: any) => {
        //     if (result) {

        //       this.historyCreated.emit(result.createdMessage);
        //     }
        //   },
        //   (err: HttpErrorResponse) => {
        //     this.httpLoader.hideLoader();
        //   }
        // );
      },

      error: err => {
        console.error('LLM error:', err);
        this.resetBotState();
        this.startMic();
      }
    });

    this.scrollToBottom();
  }

  async startRecording(stream: MediaStream) {
    this.audioContext = this.audioContext || new AudioContext({
      sampleRate: this.sampleRate
    });

    this.micSource = this.audioContext.createMediaStreamSource(stream);

    this.processor = this.audioContext.createScriptProcessor(4096, 1, 1);

    this.micSource.connect(this.processor);
    this.processor.connect(this.audioContext.destination);

    this.processor.onaudioprocess = (event) => {
      const input = event.inputBuffer.getChannelData(0);
      this.recordedUserChunks.push(new Float32Array(input));
    };
  }

  private resetBotState(): void {
    this.aiLoading = false;
    this.isTyping = false;
    this.isBotBusy = false;
  }



  private renderAnswerLineByLine(): void {
    let index = 0;

    const interval = setInterval(() => {
      if (index < this.answerLines.length) {
        this.transcriptLines.push(this.answerLines[index]);
        index++;
        this.scrollToBottom();
      } else {
        clearInterval(interval);
      }
    }, 400);
  }



  private startTypingEffect(text: string) {
    let i = 0;
    this.typedAnswer = '';

    const typingInterval = setInterval(() => {
      if (i < text.length) {
        this.typedAnswer += text.charAt(i);
        i++;
      } else {
        clearInterval(typingInterval);
      }
    }, this.typingSpeed);
  }

  trackById(index: number, item: any) {
    return item.sequence_id;
  }

  // stopMic(): void {
  //   if (!this.isMicActive) return;

  //   this.isMicActive = false;
  //   this.aiState = 'idle';

  //   this.botService.stopListening?.();
  //   this.botSocketService?.stopStreaming?.();

  //   this.liveSubtitle = '';
  //   this.transcriptLines = [];
  // }

  stopMic(): void {

    if (!this.isMicActive) return;

    this.isMicActive = false;
    this.aiState = 'idle';

    this.botService.stopListening?.();

    this.botSocketService?.stopStreaming?.();

    if (this.microphone) {
      this.microphone.disconnect();
    }

    if (this.analyser) {
      this.analyser.disconnect();
    }

    if (this.audioContext && this.audioContext.state !== 'closed') {
      this.audioContext.close();
    }

    if (this.mediaStream) {
      this.mediaStream.getTracks().forEach(track => track.stop());
    }

    // Reset UI
    this.liveSubtitle = '';
    this.transcriptLines = [];
  }



  async redirectBotChat(): Promise<void> {
    try {

      this.stopMic();

      // Close AudioContext safely
      if (this.audioContext && this.audioContext.state !== 'closed') {
        await this.audioContext.close();
        this.audioContext = null;
      }

      this.ttsSocketService.notifyPlaybackEnded();
      this.ttsSocketService.stopStreaming();

      this.ttsSocketService.disconnect();

      // Reset UI state
      this.aiState = 'idle';
      this.transcriptLines = [];
      this.greetingAudioDone = false;
      this.greetingTextDone = false;

      // Navigate after everything is finished
      await this.router.navigateByUrl("elibraryandcourse/e-library/" + this.llmService.llm_bot_payload['class_id']);

    } catch (error) {
      console.error('Redirect cleanup error:', error);
    }
  }


  viewTranscriptModal() {
    this.isViewTranscript = true;
  }

  closeTranscriptModal() {
    this.isViewTranscript = false;
  }

  scrollToBottom() {
    setTimeout(() => {
      const container = document.getElementById("transcriptContainer");
      if (container) container.scrollTop = container.scrollHeight;
    }, 50);
  }

  clear() {
    this.caption = [];
  }

  async initNoiseDetection() {

    const stream = await navigator.mediaDevices.getUserMedia({ audio: true });

    this.audioContext = new AudioContext();
    this.analyser = this.audioContext.createAnalyser();
    this.microphone = this.audioContext.createMediaStreamSource(stream);

    this.analyser.fftSize = 512;
    const bufferLength = this.analyser.frequencyBinCount;
    this.dataArray = new Uint8Array(bufferLength);

    this.microphone.connect(this.analyser);

    this.detectNoise();
  }

  detectNoise() {

    const check = () => {

      if (!this.isMicActive || !this.dataArray) return;

      this.analyser.getByteFrequencyData(this.dataArray);

      let sumSquares = 0;

      for (let i = 0; i < this.dataArray.length; i++) {
        const normalized = this.dataArray[i] / 255;
        sumSquares += normalized * normalized;
      }

      const rms = Math.sqrt(sumSquares / this.dataArray.length);

      // speaking detected
      if (rms > this.silenceThreshold) {
        this.silenceStart = Date.now();
      }

      // silence detected
      if (Date.now() - this.silenceStart > this.silenceDuration) {
        console.log('Silence detected');

        if (this.isMicActive) {
          this.stopMic();
        }
        return;
      }

      requestAnimationFrame(check);
    };

    this.silenceStart = Date.now();
    check();
  }

  navigateBack() {
    this.router.navigateByUrl("elibraryandcourse/e-library/" + this.llmService.llm_bot_payload['class_id']);
  }

  ngOnDestroy(): void {
    this.botService.stopListening();
    this.botService.stopSpeaking();

    // this.sub.unsubscribe();
  }


}
